<p-editor [(ngModel)]="text" [style]="{ height: '367px' }" (onTextChange)="emitTextChange()" [placeholder]="'Opinión técnica.....'" [readonly]="textReadOnly">
    <ng-template pTemplate="header">
                <span class="ql-formats">
                    <button type="button" class="ql-bold" aria-label="Bold"></button>
                    <button type="button" class="ql-italic" aria-label="Italic"></button>
                    <button type="button" class="ql-underline" aria-label="Underline"></button>
                    <button type="button" class="ql-strike" aria-label="Strikethrough"></button>
                    <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
                    <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
                    <button type="button" class="ql-align" value="" aria-label="Align Left"></button>
                    <button type="button" class="ql-align" value="center" aria-label="Align Center"></button>
                    <button type="button" class="ql-align" value="right" aria-label="Align Right"></button>
                    <button type="button" class="ql-align" value="justify" aria-label="Justify"></button>
                </span>
    </ng-template>
</p-editor>
